export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुराना पासवर्ड"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नया पासवर्ड"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पासवर्ड की पुष्टि"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सहेजें"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"नया पासवर्ड\" और \"पासवर्ड की पुष्टि\" मेल नहीं खाते।"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पासवर्ड बदलें"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["4 से 63 वर्णों की स्ट्रिंग। स्वीकार्य वर्ण: लैटिन वर्णमाला, अंक और प्रतीक"])},
  "strength": {
    "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खाली"])},
    "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कमज़ोर"])},
    "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मध्यम"])},
    "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मज़बूत"])}
  }
}